import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MenuPageBase } from "../../general/MenuPageBase";
import { MatDialog } from "@angular/material/dialog";
import { AppStatus } from "../../../@models/app-status";
import * as $ from "jquery";
import { animate, style, transition, trigger } from "@angular/animations";
import { DeviceStatusFun } from "../../../../shared/device/device-status.fun";
import { MenuCell } from "../../../../shared-gen/Model/Menus/MenuCell";
import { Router } from "@angular/router";
import { reloadAngularPage } from "../../../../../../Shared/shared/utils/router-utils";
import { AppService } from "../../../services/app.service";
import { ProductBase } from "../../../../shared-gen/Model/Products/ProductBase";
import { Choice } from "../../../../shared-gen/Model/Products/Choice";
import { ProductDetailComponent } from "../../../modals/product-detail/product-detail.component";
import { MenuPage } from "../../../../shared-gen/Model/Menus/MenuPage";
import { nullSafe } from "../../../../shared/utils/core-utils";
import { LanguageCode } from "../../../../shared-gen/Model/Localization/LanguageCode";
import {decodeEscapeCodesToHtml} from "../../../../shared/utils/text-escape-codes";

@Component({
	selector: "app-tur-menu",
	templateUrl: "./tur-menu.component.html",
	styleUrls: ["./tur-menu.component.scss"],
	animations: [
		trigger("fadeInOut", [
			transition(":enter", [   // :enter is alias to 'void => *'
				style({opacity: 0}),
				animate("0.5s ease-in-out", style({opacity: 1}))
			])
		])
	]
})
export class TurMenuComponent extends MenuPageBase implements OnInit, OnDestroy {

	theme: string = "tur";
	timer = false;

	// Scrolling
	isScrolling = false; // Start with scrolling
	restartScrollingTimer = 0;
	scrollingPauseMs = 10_000; // Defined by Sascha Schmidt, 2020-10-20

	mobileSelectEnabled = false;


	@ViewChild("overflowWrapper", {static: false}) overflowWrapper: ElementRef;
	@ViewChild("products", {static: false}) productsRef: ElementRef;


	constructor(app: AppService,
		protected dialogService: MatDialog,
		private changeDetectorRef: ChangeDetectorRef,
		private router: Router) {
		super(app, dialogService);
	}

	async ngOnInit() {
		super.ngOnInit();

		// Stop scrolling when mouse wheel is detected
		let lastOnMouseWheelTimeMs = 0;
		const onMouseWheel = () => {
			// Handle this event only once a second
			const now = new Date().getTime();
			if (now - lastOnMouseWheelTimeMs < 1000)
				return;
			lastOnMouseWheelTimeMs = now;
			// Send user action, when in inactive state
			if (DeviceStatusFun.getVmcState(this.deviceStatus) === "Inactive") {
				console.log("User action: Mousewheel scroll detected");
				this.userAction();
			}
		};
		$(".overflow-wrapper").on("mousewheel", onMouseWheel); // IE9, Chrome, Safari, Opera
		$(".overflow-wrapper").on("DOMMouseScroll", onMouseWheel); // Firefox
		$(".overflow-wrapper").scroll(() => this.scrollFun());
		$(".overflow-wrapper").on("touchmove", () => this.scrollFun());
	}

	async ngOnDestroy() {
		super.ngOnDestroy();
		// console.log("Destroy menu component. Clear timer.");
		this.clearTimer();
		clearTimeout(this.restartScrollingTimer);
	}

	onMenuChanged() {
		super.onMenuChanged();
		// Start with scrolling when the menu has changed
		this.updateScrollingStatus(true);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		this.changeDetectorRef.detectChanges();

		// Start or stop scrolling
		/* This is not dependent on VmcState any more. See calls of stopScrolling() / stopScrollingAndRestartAfter() */
		// const test_AlwaysScroll = false; // just for testing
		// const scrollingEnabled = status.deviceStatus.VendingStatus.IsUserInactive || test_AlwaysScroll;
		// this.updateScrollingStatus(scrollingEnabled);

		// When the status changed to inactive, switch language back to German
		// and open the first page
		if (nullSafe(() => status.deviceStatus.VendingStatus.IsUserInactive)) {
			this.app.translation.setLanguageCode(LanguageCode.DE);
			if (this.currentPageNumber > 0)
				this.showPage(this.menu.Pages[0]);
		}

		this.mobileSelectEnabled = nullSafe(() => status.deviceStatus.MobileSelect.Enabled) || false;
	}

	async showPage(page: MenuPage) {
		if (this.currentPage != page) {
			super.showPage(page);
			this.currentPageNumber = this.menu.Pages.indexOf(page);
			$('.overflow-wrapper')[0].scrollTo(0, 0);
			this.updateScrollingStatus(true);
			await this.app.status.reportUserActivity();
		}
	}

	private isPageAutoScroll(pageIndex: number) {
		// Auto-Startpage is always scrolling, and other pages only if flag is set
		return (this.menu.AutoStartPage && pageIndex == 0)
			|| this.menu.Pages[pageIndex].AutoScroll;
	}

	updateScrollingStatus(scrollingEnabled: boolean) {

		// When page is not yet initialized, try again a moment later
		if (!this.overflowWrapper) {
			setTimeout(() => this.updateScrollingStatus(scrollingEnabled), 100);
			return;
		}

		if (scrollingEnabled && this.isPageAutoScroll(this.currentPageNumber)) {
			this.isScrolling = true;
			if (!this.timer) {
				this.timer = true;
				const inactiveStartTimeMs = new Date().getTime();

				// TEST: measure performance
				let perfStartTimeMs = new Date().getTime();
				let perfCount = 0;

				// Timeout based timer instead of interval-based timer,
				// because if we need more time than 25 ms for an iteration,
				// the browser would freeze over time because it is overloaded
				const timerFun = () => {
					if (!this.timer)
						return;

					let now = new Date().getTime();

					/* 2021-01-02: Not needed any more: Problem was probably caused by increasing
					    number of running timers. This has been already fixed.
					// After 30 minutes of inactivity, reload menu component
					// (we observed performance problems in scrolling after some time, which disappeared
					// when changing the page)
					if (now > inactiveStartTimeMs + 30 * 60 * 1000) {
						this.clearTimer();
						this.isScrolling = false;
						reloadAngularPage(this.router);
						return;
					}
					*/

					// TEST: measure performance
					perfCount++;

					if (now - perfStartTimeMs > 10000) {
						console.log("PERF: " + perfCount + " iterations in the last 10 secs");
						perfCount = 0;
						perfStartTimeMs = now;
					}

					// Compute speed dependent on time of last call
					const speed = Math.max(0, Math.round((now - lastTimerMs) / 25));
					lastTimerMs = now;

					this.overflowWrapper.nativeElement.scrollBy(0, speed);

					if (this.timer)
						window.setTimeout(timerFun, 25);
				};

				let lastTimerMs = new Date().getTime();
				timerFun();

			}
		}
		else {
			this.clearTimer();
			this.isScrolling = false;
		}
	}

	scrollFun() {

		if (false == this.isPageAutoScroll(this.currentPageNumber))
			return;

		let cols = this.currentPage.Columns;
		let $gap = parseInt($(".products").css("grid-row-gap"));
		let articleHeight = 0;

		$("article").slice(0, cols).each((k, el) => {
			if ($(el).outerHeight() > articleHeight)
				articleHeight = $(el).outerHeight();
		});
		articleHeight += $gap;
		let scrollPos = $(".overflow-wrapper").scrollTop();
		if (scrollPos > articleHeight) {
			// TEST: count buttons // console.log("COUNT: " + ($("article").length) + " , " + this.currentPage.Cells.length);

			// Move top row to the bottom, by modifying the array of cells.
			// Before, we did this by the following DOM manipulation:
			// $("article").slice(0, cols).appendTo(".products");
			// Unfortunately, this messed up the Angular bindings, which slowed down the site after a while.
			// Now we do it by modifying the model:
			let cells: MenuCell[] = [];
			cells.push(... this.currentPage.Cells);
			for (let i = 0; i < cols; i++)
				cells.push(cells.shift());
			this.currentPage.Cells = cells;

			// Scroll to top
			$(".overflow-wrapper").scrollTop(0);

		}
	}

	clearTimer() {
		this.timer = false;
	}

	stopScrolling() {
		this.updateScrollingStatus(false);
		clearTimeout(this.restartScrollingTimer);
	}

	stopScrollingAndRestartAfter(ms: number) {
		this.stopScrolling();
		this.restartScrollingTimer = setTimeout(() => {
			this.updateScrollingStatus(true);
		}, ms);
	}

	touchStart() {
		// console.log("touchStart");
		this.userAction();
		this.stopScrollingAndRestartAfter(this.scrollingPauseMs);
	}

	onMouseWheel() {
		this.stopScrollingAndRestartAfter(this.scrollingPauseMs);
	}

	userAction() {
		this.app.api.deviceApi.userAction();
	}

	openInfo(product: ProductBase, event) {
		this.stopScrolling();
		super.openInfo(product, event);
	}

	onInfoClosed() {
		this.stopScrollingAndRestartAfter(this.scrollingPauseMs);
		super.onInfoClosed();
		if (ProductDetailComponent.lastSelectedProduct)
			this.orderProductIfAvailable(ProductDetailComponent.lastSelectedProduct, null);
	}

	async openOptionsPageOrOrder(productBase: ProductBase, event) {
		this.stopScrollingAndRestartAfter(this.scrollingPauseMs);
		return await super.openOptionsPageOrOrder(productBase, event);
	}

	async orderByChoice(productBase: ProductBase, choice: Choice, event: Event): Promise<boolean> {
		this.stopScrollingAndRestartAfter(this.scrollingPauseMs);
		return await super.orderByChoice(productBase, choice, event);
	}

	textToHtml(text: string) {
		return decodeEscapeCodesToHtml(text);
	}
}
